import React from "react";
import { Link } from "react-router-dom";
import { Grid, Typography, CircularProgress, Box, Button } from "@mui/material";
import MovieCard from "./MovieCard";
import useInfiniteMovies from "../hooks/useInfiniteMovies";

const PaginatedMovieGrid = ({ title, fetcher }) => {
  const { items, loading, error, sentinelRef, retry, hasMore } = useInfiniteMovies(fetcher);

  return (
    <div>
      <Typography
        variant="h1"
        component="h1"
        sx={{ color: '#B3B3B3', fontSize: { xs: '1.5rem', md: '2rem' }, marginBottom: 2, textAlign: 'center' }}
      >
        {title}
      </Typography>
      {error && (
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Typography sx={{ color: '#fff', mb: 1 }} role="alert">{error}</Typography>
          <Button variant="outlined" onClick={retry}>Retry</Button>
        </Box>
      )}
      <Grid container spacing={2}>
        {items.map((movie) => (
          <Grid className="Link" item xs={6} sm={4} md={3} lg={2} key={movie.id}>
            <Link
              to={`/movie/${movie.id}`}
              aria-label={`View details for ${movie.title || movie.original_name}`}
            >
              <MovieCard data={movie} />
            </Link>
          </Grid>
        ))}
      </Grid>
      <div ref={sentinelRef} style={{ width: '100%', height: 1 }} aria-hidden="true" />
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress aria-label="Loading more movies" />
        </Box>
      )}
      {!hasMore && items.length > 0 && (
        <Typography sx={{ color: '#B3B3B3', textAlign: 'center', py: 2 }}>
          End of results
        </Typography>
      )}
    </div>
  );
};

export default PaginatedMovieGrid;
